import { State } from 'modules/data';
import { AsyncDataProvider } from 'modules/data-providers';
import { FC, PropsWithChildren, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { api } from 'services/api';

import { getRequest } from '../../../selectors/pageSelectors';
import { getRequestEditMode } from '../../../selectors/requestSelectors';
import { getRuleTypeByEditMode } from '../../../utils/helpers';

interface BankAccountDataProviderProps extends PropsWithChildren {
    currencyCode?: string;
}

const BankAccountDataProvider: FC<BankAccountDataProviderProps> = (props) => {
    const { currencyCode, children } = props;

    const request = useSelector(getRequest);
    const editMode = useSelector((state: State) => getRequestEditMode(state, request));
    const ruleType = getRuleTypeByEditMode(editMode);

    const onLoad = useCallback(
        async (filterText: string | null) => {
            const response = await api.integration.getBankAccounts({
                requestId: request.id,
                ruleType,
                query: filterText,
                startFrom: 0,
                rowNum: 116,
                currencyCode,
                companyId: request.companyId,
            });

            return response.Accounts.map((c) => ({
                id: c.Id,
                text: c.Code ? `${c.Code} - ${c.Name}` : c.Name,
                currencyCode: c.CurrencyCode,
            }));
        },
        [request.id, request.companyId, currencyCode, ruleType]
    );

    return (
        <AsyncDataProvider
            cacheStorageId={`requestOptions.bankAccount.${request.id}.${currencyCode}.${editMode}`}
            pageSize={100}
            onLoad={onLoad}
        >
            {children}
        </AsyncDataProvider>
    );
};

export default BankAccountDataProvider;
